import { render, staticRenderFns } from "./LoaderGif.vue?vue&type=template&id=0257621a&scoped=true&"
var script = {}
import style0 from "./LoaderGif.vue?vue&type=style&index=0&id=0257621a&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0257621a",
  null
  
)

export default component.exports